import { Icon } from './Icon';

type IconProps = {
  color?: string;
  size?: string;
};

export const CaretDownIcon: React.FC<IconProps> = ({ color, size }) => {
  return (
    <Icon color={color} size={size}>
      <path d="M8.47266 10C7.98047 10 7.73438 10.6016 8.08984 10.957L11.5898 14.457C11.8086 14.6758 12.1641 14.6758 12.3828 14.457L15.8828 10.957C16.2383 10.6016 15.9922 10 15.5 10H8.47266Z" />
    </Icon>
  );
};
